function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Assets",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Button/4Tabs/Kosten",
  transform: "translate(-65.000000, -5.000000)",
  stroke: "#FFFFFF",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("g", {
  id: "piggy-wit",
  transform: "translate(66.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.375,6.25 C19.375,7.63071187 18.2557119,8.75 16.875,8.75",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.875,5 C8.45045916,4.22022438 10.2995408,4.22022438 11.875,5",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.3125,7.5 C5.13991102,7.5 5,7.63991102 5,7.8125 C5,7.98508898 5.13991102,8.125 5.3125,8.125 C5.48508898,8.125 5.625,7.98508898 5.625,7.8125 C5.625,7.63991102 5.48508898,7.5 5.3125,7.5",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.58333333,2.4025 C5.605,0.63 3.125,0.625 3.125,0.625 L3.64666667,4.27833333 C2.96452378,5.02171298 2.45866135,5.9092509 2.16666667,6.875 L0.625,6.875 L0.625,11.875 L2.7,11.875 C3.13153747,12.6316299 3.69944334,13.3018153 4.375,13.8516667 L4.375,16.25 C4.375,16.595178 4.65482203,16.875 5,16.875 L6.25,16.875 C6.59517797,16.875 6.875,16.595178 6.875,16.25 L6.875,15.2158333 C8.49703193,15.7582271 10.2509902,15.7614427 11.875,15.225 L11.875,16.25 C11.875,16.595178 12.154822,16.875 12.5,16.875 L13.75,16.875 C14.095178,16.875 14.375,16.595178 14.375,16.25 L14.375,13.8641667 C15.9364369,12.6232879 16.8549298,10.7443576 16.875,8.75 C16.875,3.33833333 11,0.925833333 6.58333333,2.4025 Z",
  id: "Path"
}))));
function SvgPiggySelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "19px",
    viewBox: "0 0 22 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "piggy wit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiggySelected);
export default __webpack_public_path__ + "static/media/piggy_selected.f5bc4b672a361fc892204ee5f40ba83d.svg";
export { ForwardRef as ReactComponent };